{
  "en": {
    "textEditor": {
      "editKinds": {
        "help_me_write": "writing assistance",
        "spellcheck": "grammar and spell check",
        "summarize": "summary",
        "translate": "translation"
      },
      "headers": {
        "aiTextModal": "AI {title}"
      },
      "hints": {
        "loadingDocument": "Loading document...",
        "noTextSelected": "No text selected",
        "progressMessage": "Processing...",
        "prompt": "For example: <strong>Federal States in Germany</strong> or <strong>ancient Rome</strong>"
      },
      "links": {
        "helpMeWrite": "Writing Assistance",
        "spellcheck": "Grammar and Spell Check",
        "summarize": "Summarize",
        "translate": "Translate"
      },
      "placeholder": "Create texts collaboratively with different media content such as formatted text, images, and external links.",
      "placeholders": {
        "aiPromptModal": "Enter topic..."
      }
    }
  }
}
